import './GenericToolbarItem.0368fa7fcacbd7b09cf4e8dd116babb2.css';
export default {"item":"_item_1jger_1","active":"_active_1jger_1"};